import template from "./foodPrepTime.html";
import controller from "./foodPrepTime.controller";

import "./scss/food-prep-time.scss";
import "./scss/_cb-modal.scss";
import "./scss/_cb-button.scss";
import "./scss/_cb-stepper.scss";

let foodPrepTimeComponent = {
  restrict: "E",
  bindings: {
    page: "=",
  },
  template,
  controller,
};

export default foodPrepTimeComponent;



// WEBPACK FOOTER //
// ./client/app/components/foodPrepTime/foodPrepTime.component.js